export default __webpack_public_path__ + "static/media/Deacon's Armbands of the Earthen Prison.f29ed644.jpg";